import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { SignInScreen } from "@/features/onboarding/SignInScreen";

/** Search params carry every state the sign-in screen has: an invitation, or why you are back. */
export const Route = createFileRoute("/sign-in")({
  validateSearch: z.object({
    next: z.string().optional(),
    invite: z.string().optional(),
    reason: z.enum(["expired", "denied"]).optional(),
    detail: z.string().optional(),
  }),
  component: SignIn,
});

function SignIn() {
  return <SignInScreen {...Route.useSearch()} />;
}
